<template>
	<div id="crud-sidemenu-container-for-labels" :class="'crud-sidemenu-container ' + (!isActive ? 'hidden' : '')">
		<div class="crud-sidemenu-actions-wrapper">
			<button @click="hideMenu">{{ $t('crudSideMenu.cancel') }}</button>
			<button class="with-backgound" @click="submitData">{{ mode === 'create' ?  $t('crudSideMenu.create') : $t('crudSideMenu.update') }}</button>
		</div>
		<div class="crud-sidemenu-content-wrapper">
			<label class="static-content-label" v-if="mode === 'edit'">{{ $t('crudSideMenu.id') }}</label>
			<span v-if="mode === 'edit'">{{ elementId }}</span>

			<CurdSelect
				:label="$t('crudSideMenu.status')"
				:showLabel="true"
				id="status"
				name="status"
				:placeholder="$t('crudSideMenu.selectStatus')"
				:validationRules="{required: true}"
				:options="statusOptions"
				@valueHasChanged="selectStatus"
				@hasError="hasError"
				:value="selectedStatus"
				:isManagementListener="true"
			/>

			<CrudInput
        :class="`${$route.path.indexOf('/manage/content') > -1 ? 'hidden' : ''}`"
				id="label"
				name="name"
				:placeholder="$t('crudSideMenu.addLabel')"
				type="text"
				:label="$t('crudSideMenu.label')"
				:showLabel="true"
				:hasCheckBox="false"
				:validationRules="{
					required: true,
					max: 255
				}"
				:value="name"
				@valueHasChanged="changeName"
				@hasError="hasError"
				:isManagementListener="true"
			/>

			<CurdSelect
        :class="`${$route.path.indexOf('/manage/content') > -1 ? 'hidden' : ''}`"
				:label="$t('crudSideMenu.type')"
				:showLabel="true"
				id="type"
				name="type"
				:placeholder="$t('crudSideMenu.selectType')"
				:validationRules="{required: true}"
				:options="typesOptions"
				@valueHasChanged="selectType"
				@hasError="hasError"
				:value="selectedType"
				:isManagementListener="true"
			/>

			<label class="static-content-label" v-if="mode === 'edit'">{{ $t('crudSideMenu.projects') }}</label>
			<span v-if="mode === 'edit'">{{ usages }}</span>
		</div>
	</div>
</template>
<script>
import CurdSelect from "@/drc/components/crud-components/CrudSelect";
import CrudInput from "@/drc/components/crud-components/CrudInput.vue";
import {EventCurdSideMenu, EventManagementContent} from "@/common/configurations/event-bus.js";
import * as SERVICES  from "@/drc/services/drc-request-service";
import {NOTIFICATION_TYPE} from "@/common/utils/constants";


export default {
	name: "CrudSideMenu",
	components: {CurdSelect, CrudInput},
	props: ['isActive', 'crudSideMenuData'],
	data() {
		return {
			filedsCount: 0,
			intervalTime: 500,
			maxIntervalCount: 5,
			intervalCount: 0,
			filedsChecked: 0,
			formClear: true,
			mode: '',
			selectedStatus: '',
			selectedType: '',
			name: '',
			elementId: '',
			usages: '',
			statusOptions: [
				{
					label: this.$t('crudSideMenu.approved'),
					id: 'APPROVED'
				},
				{
					label: this.$t('crudSideMenu.forApproval'),
					id: 'FOR_APPROVAL'
				},
				{
					label: this.$t('crudSideMenu.inactive'),
					id: 'INACTIVE'
				}
			],
			typesOptions: [
				{
					label: this.$t('crudSideMenu.tool'),
					id: 'TOOL'
				},
				{
					label: this.$t('crudSideMenu.certification'),
					id: 'CERTIFICATION'
				}
			]
		}

	},
	beforeDestroy() {
		localStorage.removeItem('updateAttribute');
	},
	methods: {
		hideMenu() {
			EventCurdSideMenu.$emit('toggle-side-menu');
			this.resetForm();
		},
		selectStatus(data) {
			this.selectedStatus = data.value;
		},
		selectType(data) {
			this.selectedType = data.value;
		},
		changeName(data) {
			this.name = data.value;
		},
		async submitData() {
			let allValidated =  await this.checkValidations();
			if (!allValidated) {
				return;
			}else{
				this.$store.dispatch('showLoading');
			}

			let data = {
				'name': this.name,
				'type': this.selectedType,
				'status': this.selectedStatus
			}
			if (this.mode === 'create') {
				this.create(data);
			} else {
				this.update(data);
			}
		},
		create(data) {
			const searchString = `?text=${data.name}&page=0&size=99999&sort=name,asc`;
			SERVICES.searchQualificationAttributes(searchString).then(res => {
				let hasDuplicate = false;
				if (res.data.length > 0) {
					res.data.forEach(el => {
						if( el.name.toLowerCase() === data.name.toLowerCase() && el.type.toLowerCase() === data.type.toLowerCase()) {
							this.$store.dispatch('hideLoading');
							hasDuplicate = true;
							return;
						}
					})
				}else{
					hasDuplicate = false;
				}
				if (hasDuplicate) {
					this.showNotification("You cannot have duplicated tool/certificate.", NOTIFICATION_TYPE.ERROR);
					return;
				}else{
					SERVICES.saveQualificationAttribute(data)
						.then(() => {
							this.$store.dispatch('hideLoading');
							this.hideMenu();
							EventManagementContent.$emit('refreshContent');
							this.resetForm();

							let message = `${this.$t('formsNotifications.successCreatedQualificationAttribute')} ` + (data.type.toLowerCase() === 'tool'
								? `${this.$t('formsNotifications.tool')}`
								: `${this.$t('formsNotifications.certificate')}`);
							this.showNotification(message, NOTIFICATION_TYPE.SUCCESS);
						}).catch((error) => {
						let responseMessage = error.response.data.message
						if (responseMessage.includes("Duplicate entry")) {
							this.showNotification("You cannot have duplicated tool/certificate.", NOTIFICATION_TYPE.ERROR);
						} else {
							this.showNotification(this.$i18n.t('formsNotifications.somethingWentWrong'), NOTIFICATION_TYPE.ERROR);
						}
						this.$store.dispatch('hideLoading');
					});
				}
			}).catch(() => {
				this.$store.dispatch('hideLoading');
				this.showNotification(this.$t('formsNotifications.somethingWentWrong'), NOTIFICATION_TYPE.ERROR);
				return;
			})
		},
		update(data) {
			const vue = this;
			const searchString = `?text=${data.name}&page=0&size=99999&sort=name,asc`;
			SERVICES.searchQualificationAttributes(searchString).then(res => {
				let hasDuplicate = false;
				if (res.data.length > 0) {
					res.data.forEach(el => {
						if (el.name.toLowerCase() === data.name.toLowerCase() && el.type.toLowerCase() === data.type.toLowerCase() && vue.elementId !== el.id) {
							this.$store.dispatch('hideLoading');
							hasDuplicate = true;
							return;
						}
					})
				} else {
					hasDuplicate = false;
				}
				if (hasDuplicate) {
					this.showNotification("You cannot have duplicated tool/certificate.", NOTIFICATION_TYPE.ERROR);
					return;
				} else {
					data.id = this.elementId;
					SERVICES.updateQualificationAttribute(data)
						.then(() => {
							this.resetForm();
							this.$store.dispatch('hideLoading');
							this.hideMenu();
							EventManagementContent.$emit('refreshContent');

							let message = `${this.$t('formsNotifications.successUpdatedQualificationAttribute')} ` + (data.type.toLowerCase() === 'TOOL'
								? `${this.$t('formsNotifications.tool')}`
								: `${this.$t('formsNotifications.certificate')}`);
							this.showNotification(message, NOTIFICATION_TYPE.SUCCESS);
							localStorage.setItem("updateAttribute", JSON.stringify(data));
						}).catch((error) => {
							let responseMessage = error.response.data.message
							if (responseMessage.includes("Duplicate entry")) {
								this.showNotification("You cannot have duplicated tool/certificate.", NOTIFICATION_TYPE.ERROR);
							} else {
								this.showNotification(this.$i18n.t('formsNotifications.somethingWentWrong'), NOTIFICATION_TYPE.ERROR);
							}
							this.$store.dispatch('hideLoading');
						});
				}
			});
		},
		resetForm() {
			this.selectedStatus = '';
			this.selectedType = '';
			this.name = '';
		},
		showNotification(message, type) {
			this.$store.dispatch('addNotification', {type, message});
		},
		checkValidations() {
			const vue = this;
			return new Promise((resolve) => {
				vue.resetCounters();
				EventManagementContent.$emit('validateStep');

				vue.filedsCount = document.getElementsByClassName('auto-validate-mc').length
				let localInterval = setInterval(() => {
					const errors = document.getElementById('crud-sidemenu-container-for-labels').getElementsByClassName('errors-container').length
					if(errors > 0) {
						clearInterval(localInterval);
						return resolve(false);
					}

					if (vue.filedsCount === vue.filedsChecked) {
						return resolve(true);
					}

					if (vue.intervalCount === vue.maxIntervalCount) {
						clearInterval(localInterval);
						return resolve(false);
					}

					vue.intervalCount++
				}, vue.intervalTime);
			});
		},
		fieldChecked() {
			this.filedsChecked++;
		},
		resetCounters() {
			this.intervalCount = 0;
			this.filedsChecked = 0;
		},
		hasError(data) {
			if(this.formClear === true) {
				this.formClear = data;
			}
			this.fieldChecked();
		}
	},
	watch: {
		crudSideMenuData(newValue) {
			if (newValue !== '' && newValue) {
				this.mode = newValue.type;
				if (newValue.type === 'edit') {
					this.elementId = newValue.row.id;
					this.usages = newValue.row.projectCount;
					this.name = newValue.row.name;
					this.selectedStatus = newValue.row.status.toUpperCase();
					this.selectedType = newValue.row.type.toUpperCase();
				}
			}
		},
		isActive(newStatus){
			this.$nextTick(() => {
				if(newStatus === true && this.crudSideMenuData.type !== 'create'){
					this.checkValidations();
				}
			});
		},
		'$i18n.locale': {
			immediate: true,
			handler() {
				this.statusOptions = [
					{
						label: this.$t('crudSideMenu.approved'),
						id: 'APPROVED'
					},
					{
						label: this.$t('crudSideMenu.forApproval'),
						id: 'FOR_APPROVAL'
					},
					{
						label: this.$t('crudSideMenu.inactive'),
						id: 'INACTIVE'
					}
				];
					this.typesOptions = [
					{
						label: this.$t('crudSideMenu.tool'),
						id: 'TOOL'
					},
					{
						label: this.$t('crudSideMenu.certification'),
						id: 'CERTIFICATION'
					}
				]
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.hidden{
  display: none;
}
</style>
